var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInnovation = function SvgInnovation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 82,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#innovation_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#innovation_svg__b)",
    d: "M25.247 62.88h15.466c.012-.274.03-.554.037-.834.042-1.76-.031-3.53.15-5.275.229-2.2 1.408-3.92 3.155-5.287 1.661-1.3 3.403-2.535 4.883-4.021 3.15-3.162 4.93-7.06 5.648-11.443.021-.131.034-.265.063-.395.2-.877.712-1.306 1.424-1.199.712.108 1.085.687.956 1.578-.678 4.683-2.467 8.901-5.686 12.399a31 31 0 0 1-4.999 4.362c-2.205 1.547-3.32 3.463-3.18 6.139.06 1.17.026 2.348.002 3.522-.009.442.096.721.523.952 1.018.55 1.58 1.44 1.582 2.6.002 1.185.235 2.412-.492 3.506-.066.1-.046.322.023.435.767 1.266.533 2.653.407 3.986-.13 1.373-1.408 2.434-2.841 2.489-1.307.05-2.617.01-4.025.01 0 .9.007 1.692-.002 2.484-.02 1.953-1.15 3.089-3.095 3.102-1.531.01-3.062.016-4.593-.002-1.805-.02-2.958-1.164-2.997-2.958-.019-.824-.004-1.649-.004-2.605-1.17 0-2.29.046-3.402-.018-.654-.037-1.346-.141-1.933-.408-.901-.41-1.486-1.213-1.545-2.197-.079-1.31-.326-2.664.424-3.912.093-.154-.06-.478-.141-.71-.522-1.483-.585-2.992.01-4.438.223-.543.846-.916 1.25-1.397.211-.253.474-.568.486-.864.052-1.332-.006-2.668.03-4.002.063-2.43-.931-4.235-3.007-5.546-3.709-2.342-6.608-5.475-8.5-9.411-3.924-8.163-3.552-16.2 1.323-23.85 3.882-6.093 9.579-9.637 16.741-10.837q.24-.04.48-.059c.84-.062 1.392.304 1.498.99.1.651-.352 1.205-1.16 1.381-1.02.224-2.068.351-3.064.652-8.086 2.44-13.307 7.74-15.361 15.86-2.27 8.968 1.428 18.083 9.212 23.146 2.95 1.918 4.38 4.496 4.262 7.977-.046 1.352-.008 2.706-.008 4.098m7.778 2.449h-8.136q-1.758 0-1.754 1.782c.003 1.249.124 1.373 1.38 1.373q8.177.002 16.352.001 2.028 0 1.996-2.043c-.015-.96-.162-1.11-1.139-1.112-2.9-.004-5.8-.001-8.7-.001m-.108 8.686h8.132q1.82 0 1.814-1.799c-.003-1.233-.087-1.32-1.329-1.32H25.11q-1.996 0-1.975 1.958c.01 1.02.141 1.158 1.168 1.16 2.871.004 5.743.001 8.614.001m3.004 2.466h-5.837c0 .877-.04 1.703.028 2.52.018.21.375.55.585.556 1.528.048 3.058.052 4.585-.002.22-.007.587-.382.61-.614.076-.79.029-1.592.029-2.46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#innovation_svg__c)",
    d: "M36.868 20.583c.6.254 1.155.526 1.737.711.184.059.503-.05.657-.191.67-.616 1.296-1.277 1.948-1.912 1.06-1.032 1.948-1.04 2.994-.02a189 189 0 0 1 2.506 2.49c1.03 1.041 1.018 1.91-.029 2.967-.602.61-1.19 1.235-1.83 1.803-.394.35-.315.637-.195 1.098.32 1.224 1.02 1.637 2.248 1.445.629-.099 1.287-.037 1.93-.009 1.06.045 1.722.659 1.752 1.7q.063 2.122.001 4.243c-.032 1.09-.722 1.7-1.9 1.735a50 50 0 0 1-2.82 0c-.426-.012-.662.083-.832.531-.582 1.541-.607 1.532.574 2.705.436.434.893.85 1.303 1.308.736.82.764 1.716.017 2.509a62 62 0 0 1-2.964 2.94c-.794.736-1.717.708-2.52-.03a32 32 0 0 1-1.99-1.983c-.365-.4-.66-.385-1.174-.25-1.252.327-1.606 1.063-1.427 2.254.087.574.029 1.172.012 1.758-.036 1.22-.687 1.88-1.907 1.9q-1.973.03-3.947-.002c-1.178-.02-1.842-.674-1.876-1.844-.028-.96-.032-1.922.004-2.881.017-.45-.185-.599-.552-.82-1.141-.685-1.992-.492-2.75.582-.335.474-.809.854-1.243 1.251-.87.795-1.78.808-2.642-.005a80 80 0 0 1-2.792-2.772c-.854-.889-.85-1.785.001-2.685.662-.7 1.349-1.377 2.052-2.036.3-.282.344-.513.172-.895-.684-1.521-.669-1.528-2.331-1.528-.564 0-1.128.014-1.692-.004-1.284-.04-1.942-.672-1.965-1.927a97 97 0 0 1 .003-3.922c.027-1.184.677-1.809 1.872-1.835.94-.021 1.88-.027 2.819.003.465.015.645-.168.89-.569.705-1.15.46-1.97-.595-2.725-.494-.354-.9-.839-1.312-1.295-.714-.791-.754-1.681-.04-2.442a60 60 0 0 1 3.019-2.998c.824-.762 1.713-.702 2.58.11a45 45 0 0 1 2.047 2.04c.287.304.517.273.9.177 1.302-.326 1.797-1.071 1.566-2.393-.104-.595-.043-1.226-.007-1.837.06-1.018.638-1.668 1.66-1.713 1.447-.064 2.9-.066 4.347-.007 1.097.045 1.689.718 1.715 1.828.028 1.146.006 2.292.006 3.442m-2.42 27.26c0-1.181.027-2.323-.01-3.463-.027-.856.367-1.325 1.157-1.597a28 28 0 0 0 2.528-1.014c1.084-.499 1.378-.485 2.203.342.786.788 1.557 1.59 2.29 2.342l2.182-2.102c-.732-.682-1.467-1.341-2.173-2.03-1.163-1.134-1.164-1.273-.458-2.692.295-.594.554-1.212.767-1.84.5-1.473.58-1.547 2.177-1.547h3.015v-2.878c-1.205 0-2.355-.008-3.504.003-.805.008-1.282-.348-1.55-1.119a23 23 0 0 0-1.135-2.722c-.381-.768-.271-1.363.344-1.933.843-.782 1.663-1.59 2.454-2.349l-2.092-2.161c-.81.837-1.616 1.655-2.405 2.49-.571.604-1.166.728-1.943.335a19 19 0 0 0-2.664-1.102c-.845-.277-1.22-.764-1.193-1.646.037-1.138.01-2.277.01-3.419H31.55c0 1.163.003 2.278-.001 3.393-.004 1.052-.223 1.312-1.235 1.684-.852.313-1.695.657-2.52 1.036-.995.456-1.3.44-2.068-.324-.81-.805-1.602-1.626-2.277-2.313l-2.17 2.009c.824.803 1.64 1.615 2.476 2.405.587.555.677 1.138.316 1.87a26 26 0 0 0-1.085 2.572c-.389 1.059-.666 1.287-1.826 1.29-1.092.005-2.184.002-3.3.002v2.877c1.216 0 2.39.018 3.564-.006.79-.017 1.23.342 1.487 1.07q.466 1.317 1.059 2.583c.5 1.068.482 1.36-.35 2.189-.789.787-1.588 1.565-2.315 2.28l2.036 2.14c.802-.823 1.576-1.633 2.368-2.426.764-.766 1.096-.79 2.068-.347a34 34 0 0 0 2.522 1.03c1.031.373 1.247.638 1.25 1.759.003 1.11 0 2.22 0 3.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#innovation_svg__d)",
    d: "M36.042 8.758c2.757.325 5.451 1.114 7.961 2.435 6.745 3.548 11 9.026 12.725 16.424.144.622.228 1.258.32 1.89.135.93-.213 1.524-.951 1.66-.698.129-1.225-.358-1.434-1.284-.317-1.401-.512-2.848-1.001-4.188-2.977-8.15-8.834-12.933-17.396-14.48-.211-.039-.426-.06-.631-.118-.704-.198-1.098-.732-1.002-1.336.1-.635.608-1.016 1.409-1.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#innovation_svg__e)",
    d: "M34.202 3.182c0 .639.03 1.279-.008 1.915-.046.777-.52 1.258-1.175 1.271-.645.013-1.184-.477-1.207-1.23a62 62 0 0 1 0-3.91c.023-.756.557-1.24 1.207-1.228.656.012 1.105.493 1.183 1.267a2 2 0 0 1 .008.16v1.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#innovation_svg__f)",
    d: "M3.234 33.974c-.67 0-1.34.013-2.009-.004-.732-.018-1.14-.434-1.219-1.132-.068-.602.421-1.192 1.123-1.22a49 49 0 0 1 4.173.007c.709.032 1.16.612 1.093 1.235-.077.714-.513 1.092-1.232 1.112-.643.017-1.286.003-1.929.002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#innovation_svg__g)",
    d: "M62.806 33.972c-.67 0-1.34.026-2.008-.007-.712-.034-1.202-.511-1.196-1.143.006-.684.387-1.16 1.056-1.188a50 50 0 0 1 4.25-.005c.697.03 1.169.646 1.082 1.248-.102.698-.529 1.087-1.256 1.097-.642.01-1.285.002-1.928.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#innovation_svg__h)",
    d: "M10.441 9.095c.442.267.797.407 1.053.649a87 87 0 0 1 2.562 2.534c.604.618.635 1.34.12 1.836-.484.466-1.212.442-1.792-.114-.905-.868-1.832-1.723-2.645-2.673-.269-.316-.366-.945-.259-1.357.088-.337.598-.565.961-.875"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#innovation_svg__i)",
    d: "M56.846 10.357c-.26.438-.393.796-.637 1.052a86 86 0 0 1-2.55 2.546c-.617.596-1.353.64-1.849.148-.504-.5-.464-1.218.144-1.837.878-.895 1.741-1.812 2.694-2.623.3-.255.916-.351 1.301-.237.349.104.58.594.897.951"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#innovation_svg__j)",
    d: "M13.457 51.04c.28.211.754.395.889.718.148.355.152.985-.073 1.24-.952 1.076-1.99 2.082-3.045 3.061-.471.438-1.061.366-1.527-.072-.434-.407-.605-.988-.192-1.437 1.026-1.117 2.128-2.167 3.219-3.225.139-.135.388-.157.73-.286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#innovation_svg__k)",
    d: "M52.562 50.985c.413.228.76.34.997.564a83 83 0 0 1 2.675 2.649c.584.604.596 1.27.095 1.773-.502.502-1.179.496-1.788-.083-.909-.865-1.833-1.724-2.647-2.673-.276-.32-.393-.948-.29-1.362.085-.339.606-.57.958-.868"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#innovation_svg__l)",
    d: "M32.97 26.378c3.548-.022 6.462 2.836 6.49 6.365.028 3.544-2.916 6.492-6.473 6.48-3.535-.01-6.44-2.904-6.448-6.423-.009-3.526 2.87-6.4 6.432-6.422m-4.008 6.416c.002 2.208 1.826 4.025 4.04 4.023s4.035-1.82 4.034-4.029c0-2.22-1.8-4.003-4.04-4.002-2.238.002-4.036 1.787-4.034 4.008"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "innovation_svg__b",
    x1: -1.716,
    x2: 62.24,
    y1: 58.462,
    y2: 58.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "innovation_svg__c",
    x1: 7.829,
    x2: 54.393,
    y1: 39.04,
    y2: 39.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "innovation_svg__d",
    x1: 29.806,
    x2: 59.483,
    y1: 23.978,
    y2: 23.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "innovation_svg__e",
    x1: 31.259,
    x2: 34.474,
    y1: 4.321,
    y2: 4.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "innovation_svg__f",
    x1: -1.372,
    x2: 7.088,
    y1: 33.208,
    y2: 33.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "innovation_svg__g",
    x1: 58.231,
    x2: 66.686,
    y1: 33.212,
    y2: 33.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "innovation_svg__h",
    x1: 8.345,
    x2: 15.084,
    y1: 12.723,
    y2: 12.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "innovation_svg__i",
    x1: 50.309,
    x2: 57.423,
    y1: 12.807,
    y2: 12.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "innovation_svg__j",
    x1: 8.164,
    x2: 15.005,
    y1: 54.646,
    y2: 54.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "innovation_svg__k",
    x1: 50.47,
    x2: 57.238,
    y1: 54.615,
    y2: 54.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "innovation_svg__l",
    x1: 23.77,
    x2: 40.844,
    y1: 35.095,
    y2: 35.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "innovation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h66v82H0z"
  })))));
};
export default SvgInnovation;